import styled from '@emotion/styled';

import { SPACING } from '../../../../../styles/emotion';
import { CheckboxFieldAdapter } from '../../../../Form/CheckboxField';

export const StyledFormCheckbox = styled(CheckboxFieldAdapter)`
  margin-top: ${SPACING.S16};
`;
